module.exports = __webpack_public_path__ + "img/safe-finances-banner.d1cf6deb.png";